export enum OrganizationTypes {
    CARRIER = 'CARRIER', // Transportista
    SHIPPER = 'SHIPPER', // Dador de carga
    OMS = 'OMS', // Organización dada de alta para OMS
}
